/* global Word */
import type { TemplateProfile } from '../templates';
import type { ElementDefinition } from './types';
import { TableBuilder } from '../word/builders/TableBuilder';
import { cmToPt } from '../core/utils/math';

const H_PAD_PT = 14;
const V_PAD_TOP = 18;
const V_PAD_BOT = 10;

function toHex(color: string): string {
  return color.startsWith('#') ? color : `#${color}`;
}

/** Insert box summary full-width shaded box. */
export async function insertBoxSummaryElement(profile: TemplateProfile): Promise<void> {
  await Word.run(async (ctx) => {
    const anchorPara = ctx.document.getSelection().paragraphs.getFirst();
    const table = anchorPara.insertTable(1, 1, Word.InsertLocation.before, [['']]);
    TableBuilder.clearAllBorders(table);

    await ctx.sync();

    const cell = table.getCell(0, 0);
    // Lock the table width and set cell column width to match "Text Full" element (18.00 cm)
    TableBuilder.lockWidth(table, cmToPt(18.70));
    cell.columnWidth = cmToPt(18.055);
    cell.shadingColor = '#D9D9D9';
    TableBuilder.clearCellBorders(cell);

    const contentPara = cell.body.paragraphs.getFirst();
    contentPara.alignment = Word.Alignment.justified;
    contentPara.spaceBefore = V_PAD_TOP;
    contentPara.spaceAfter = V_PAD_BOT;
    contentPara.leftIndent = H_PAD_PT;
    contentPara.rightIndent = H_PAD_PT;
    contentPara.lineSpacing = 13.8;
    contentPara.font.name = profile.typography.fontFamily;
    contentPara.font.size = profile.typography.graphHintSize;
    contentPara.font.bold = false;
    contentPara.font.color = toHex(profile.colorPalette.sourceText);

    await ctx.sync();
  });
}

/** Element definition for box summary insertion. */
export const boxSummaryElement: ElementDefinition = {
  id: 'box-summary',
  label: 'Box Summary',
  icon: 'TextboxRegular',
  description: 'Full-width shaded text box for summary content',
  category: 'text',
  templateIds: ['base'],
  insertAsync: insertBoxSummaryElement,
};


